import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import { Editing } from "devextreme-react/scheduler";
import { ButtonItem } from "devextreme-react/tree-list";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarTaxasDs,
  criarReceitasDs,
  criarParametroIptuDs,
} from "../../DataSources";
import uiInfo from "../../ui-info";
import {
  Column,
  DataGrid,
  Paging,
  Pager,
  Format,
  Lookup,
} from "devextreme-react/data-grid";
import PaginaToolbar from "../../components/PaginaToolbar";
import ShowError from "../../AppServices";

const template = {
  id: undefined,
  prefeituraId: undefined,
  ano: undefined,
  mensagem: undefined,
  observacao: undefined,
  valorMinimo: undefined,
  valorMaximo: undefined,
  faixas: [],
  parcelas: [],
};

export default class ParametrosIptuForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    template.prefeituraId = UserInfo.getPrefeitura();
    this.parametrosIptuDs = criarParametroIptuDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    this.tipoParcela = [
      { id: 0, descricao: "NAO INFORMADO" },
      { id: 1, descricao: "COTA UNICA COM DESCONTO" },
      { id: 2, descricao: "COTA UNICA SEM DESCONTO" },
      { id: 3, descricao: "PARCELAMENTO" },
      { id: 4, descricao: "PARCELA UNICA" },

    ];

    this.anoVigenteOptions = {
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: " " },
        { id: 1, descricao: "SIM" },
        { id: 2, descricao: "NAO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.parametrosIptuDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (data == undefined) {
            notify("Taxa não encontrada.", "error");
            this.props.history.push("/taxas");
          }
          this.setState(data);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }

    if (this.props.match.params.id === undefined) {
      this.setState({ ...template });
    }
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <Form formData={this.state} colCount={2}>
          <GroupItem caption="PARÂMETROS DE IPTU" colSpan={2} colCount={3}>
            <SimpleItem colSpan={3} dataField={"ano"}>
              <Label text="Ano" />
            </SimpleItem>
            

            <SimpleItem
              dataField={"mensagem"}
              editorType={"dxTextArea"}
              editorOptions={{ height: "80px" }}
              colSpan={3}
            >
              <Label text="Mensagem" />
            </SimpleItem>
            <SimpleItem
              dataField={"obs"}
              editorType={"dxTextArea"}
              editorOptions={{ height: "80px" }}
              colSpan={3}
            >
              <Label text="Observação" />
            </SimpleItem>

            <SimpleItem
              colSpan={1}
              dataField={"minimo"}
              editorType={"dxNumberBox"}
              editorOptions={{ format: { type: "fixedPoint", precision: 2 } }}
            >
              <Format type={"fixedPoint"} precision={2} />
              <Label text="Valor Mínimo" />
            </SimpleItem>
            <SimpleItem
              colSpan={1}
              dataField={"maximo"}
              editorType={"dxNumberBox"}
              editorOptions={{ format: { type: "fixedPoint", precision: 2 } }}
            >
              <Label text="Valor Máximo" />
              <Format type={"fixedPoint"} precision={2} />
            </SimpleItem>
            <SimpleItem
              colSpan={1}
              dataField={"anoVigente"}
              editorType={"dxSelectBox"}
              editorOptions={this.anoVigenteOptions}
            >
              <Label text="IPTU Vigente" />
            </SimpleItem>
          </GroupItem>
        </Form>

        <PaginaToolbar titulo="">
          <DataGrid
            dataSource={this.state.faixas}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            wordWrapEnabled={true}
            onInitNewRow={this.initNewRow}
          >
            <Editing
              mode={"row"}
              allowAdding={false}
              allowUpdating={true}
              allowDeleting={true}
              useIcons={true}
            />
            <Column
              dataField={"id"}
              caption={"#"}
              allowEditing={false}
              visible={false}
            />
            <Column
              dataField={"inicial"}
              caption={"Valor Inicial"}
              dataType={"number"}
              sortIndex={1}
              sortOrder="asc"
            >
              <Format type={"fixedPoint"} precision={2} />
            </Column>
            <Column
              dataField={"final"}
              caption={"Valor Final"}
              dataType={"number"}
            >
              <Format type={"fixedPoint"} precision={2} />
            </Column>
            <Column dataField={"qtdeDeParcelas"} caption={"Qtde. Parcelas"} />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>

        <br></br>

        <PaginaToolbar titulo="">
          <DataGrid
            dataSource={this.state.parcelas}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            wordWrapEnabled={true}
            onInitNewRow={this.initNewRow}
          >
            <Editing
              mode={"row"}
              allowAdding={false}
              allowUpdating={true}
              allowDeleting={true}
              useIcons={true}
            />
            <Column
              dataField={"id"}
              caption={"#"}
              allowEditing={false}
              visible={false}
            />
            <Column
              dataField={"ordemCarne"}
              caption={"Ordem"}
              width={90}
              sortIndex={1}
              sortOrder="asc"
            />
            <Column dataField={'tipoParcela'} caption={"Tipo"} width={250}>
              <Lookup
                dataSource={this.tipoParcela}
                valueExpr={"id"}
                displayExpr={"descricao"} />
            </Column>
            <Column
              dataField={"numero"}
              caption={"Número"}
            />
            <Column dataField={"descricao"} caption={"Descrição"} />
            <Column dataField={"data"} caption={"Data"} dataType={"date"} />
            <Column dataField={"desconto"} caption={"% Desc."}>
              <Format type={"fixedPoint"} precision={2} />
            </Column>
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>

        <br></br>

        <Form>
          <GroupItem colCount={6}>
            <ButtonItem
              horizontalAlignment={"left"}
              buttonOptions={{
                type: "success",
                text: "Salvar",
                onClick: this.ok,
              }}
            />
            <ButtonItem
              horizontalAlignment={"left"}
              buttonOptions={{
                type: "warn",
                text: "Cancelar",
                onClick: this.cancel,
              }}
            />
          </GroupItem>
        </Form>
      </div>
    );
  }

  initNewRow(e) {
    e.data.prefeituraId = UserInfo.getPrefeitura();
  }

  ok() {
    const entidade = this.state;
    inserirOuAtualizar(this.parametrosIptuDs, entidade)
      .then(
        function () {
          notify("Parâmetro de IPTU cadastrado com sucesso.", "success");
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    localStorage.setItem("grid1", JSON.stringify(this.state.grid1));
    localStorage.setItem("grid2", JSON.stringify(this.state.grid2));
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
